import produce from 'immer';
import * as Selector from './selectors';

const defaultState = {
    intl: {
        locale: 'de',
        messages: {},
    },
    choices: {
        ...Selector.educatedGuessChoices(),
    },
};

export default (state = { ...defaultState }, action) =>
    produce(state, draft => {
        let guesses;
        switch (action.type) {
            case 'SET__LANGUAGE':
                draft.intl.locale = action.locale;
                draft.intl.messages = action.messages;
                break;
            case 'SET_CHOICE__INSTALLATIONSSYSTEM':
                draft.choices.installationssystem = action.value;
                guesses = Selector.educatedGuessChoices({
                    ...draft.choices,
                    wandaufbau: null,
                    steinsorte: null,
                    wandstaerke: null,
                    putz: null,
                    abwasserFallleitung: null,
                    abwasserAnschlussleitung: null,
                });
                draft.choices.wandaufbau = guesses.wandaufbau;
                draft.choices.steinsorte = guesses.steinsorte;
                draft.choices.wandstaerke = guesses.wandstaerke;
                draft.choices.putz = guesses.putz;
                draft.choices.abwasserFallleitung = guesses.abwasserFallleitung;
                draft.choices.abwasserAnschlussleitung = guesses.abwasserAnschlussleitung;
                break;
            case 'SET_CHOICE__WANDAUFFBAU':
                draft.choices.wandaufbau = action.value;
                guesses = Selector.educatedGuessChoices({ ...draft.choices, steinsorte: null, wandstaerke: null, putz: null });
                draft.choices.steinsorte = guesses.steinsorte;
                draft.choices.wandstaerke = guesses.wandstaerke;
                draft.choices.putz = guesses.putz;
                draft.choices.abwasserFallleitung = guesses.abwasserFallleitung;
                draft.choices.abwasserAnschlussleitung = guesses.abwasserAnschlussleitung;
                break;
            case 'SET_CHOICE__STEINSORTE':
                draft.choices.steinsorte = action.value;
                guesses = Selector.educatedGuessChoices({ ...draft.choices, wandstaerke: null, putz: null });
                draft.choices.wandstaerke = guesses.wandstaerke;
                draft.choices.putz = guesses.putz;
                draft.choices.abwasserFallleitung = guesses.abwasserFallleitung;
                draft.choices.abwasserAnschlussleitung = guesses.abwasserAnschlussleitung;
                break;
            case 'SET_CHOICE__WANDSTAERKE':
                draft.choices.wandstaerke = action.value;
                guesses = Selector.educatedGuessChoices({ ...draft.choices, putz: null });
                draft.choices.putz = guesses.putz;
                draft.choices.abwasserFallleitung = guesses.abwasserFallleitung;
                draft.choices.abwasserAnschlussleitung = guesses.abwasserAnschlussleitung;
                break;
            case 'SET_CHOICE__PUTZ':
                draft.choices.putz = action.value;
                break;
            case 'SET_CHOICE__TRINKWASSER_STEIGSTRANG':
                draft.choices.trinkwasserSteigstrang = action.value;
                break;
            case 'SET_CHOICE__TRINKWASSER_ANSCHLUSSLEITUNG':
                draft.choices.trinkwasserAnschlussleitung = action.value;
                break;
            case 'SET_CHOICE__ABWASSER_FALLLEITUNG':
                draft.choices.abwasserFallleitung = action.value;
                guesses = Selector.educatedGuessChoices({ ...draft.choices });
                draft.choices.abwasserAnschlussleitung = guesses.abwasserAnschlussleitung;
                break;
            case 'SET_CHOICE__ABWASSER_ANSCHLUSSLEITUNG':
                draft.choices.abwasserAnschlussleitung = action.value;
                guesses = Selector.educatedGuessChoices({ ...draft.choices });
                draft.choices.abwasserAnschlussleitung = guesses.abwasserAnschlussleitung;
                break;
        }
    });
